import React, {useContext} from "react";
import {ReactSVG} from "react-svg";
import check from "../../../../images/check.svg";
import "./MtplTarifficationDescriptionStyles.scss"
import {useMediaQuery} from "@material-ui/core";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

interface TarifficationDescriptionProps {
    title: string
    lines: Array<string>
}

export const TarifficationDescription = ({title, lines}: TarifficationDescriptionProps) => {
    const isTabletOrMobile = useMediaQuery('(max-width: 1023px)');

    const createDescriptionLine = (label: string) =>
        <div className={"tariffication-description__content__element"}>
            <div className={"tariffication-description__content__element__icon"}>
                {isTabletOrMobile ? <FiberManualRecordIcon/> : <ReactSVG src={check}/>}
            </div>
            <span>{label}</span>
        </div>

    return <div className={"tariffication-description"}>
            <div className={"tariffication-description__header"}>
				<span>{title}</span>
            </div>
            <div className={"tariffication-description__content"}>
                {lines.map(createDescriptionLine)}
            </div>
        </div>
}
